export default __webpack_public_path__ + "static/media/veterinario.c62e0a82.jpg";